module.exports = __webpack_public_path__ + "img/file-management.43d9a991.svg";